const LANGUAGE_FALLBACKS = {
    'no-NO': 'nb-NO',
    no: 'nb'
};

// react-intl and google maps expect a different locale format from the standard
// ex. "en-US" or "en"
// "no" locale is not valid language, we have to use "nb" instead
export function formatLocale(locale) {
    const langCountryPair = locale && locale.match(/^.{2}_.{2}/);
    let formattedLocale = locale && locale.slice(0, 2);

    if (langCountryPair) {
        formattedLocale = langCountryPair[0].replace('_', '-');
    }

    return LANGUAGE_FALLBACKS[formattedLocale] || formattedLocale;
}

// returns correct language from locale
export function getLanguageFromLocale(locale) {
    return formatLocale(locale).split(/_|-/)[0];
}
